<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Reading Food</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Workshop</p>
        <p>Reading food is an exercise in tracing the routes that our food crosses in order to reach our plates, focusing on the materiality of this process that is most often concealed from us or difficult to untangle. </p>
        <p>The workshop was organized as a part of Hackers&Designers' Summer Academy in 2021, which took place simultaneously in Amsterdam, Harare, Pittsburgh and Vienna. Read more information on their <a href="https://hackersanddesigners.nl/s/Summer_Academy_2021/p/Reading_food_with_Relearn_and_Varia">website</a>. Photos by Zazie Stevens.</p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/readingfood.png"></b-img>


      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/readingfood/reading_2.jpg"></b-img>
        <p></p>

        <b-img class="img-fluid" src="media/readingfood/Relearn7.jpg"></b-img>
      <p></p>

      </b-col>
    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'ReadingFoodPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
